<script>
/* eslint-disable no-console */
/**
 * Input component
 */
export default {

  methods: {
    dateValue() {

      if((this.type == 'date') && (this.value == undefined || this.value == '')) {
        const current = this.$moment().clone().format('YYYY-MM-DD') + "";


        console.log(this.date);
        
        this.value = current;
        return this.date ? current : '';
      }

      return this.value;
    },

    onBlur(event) {
      // $emit('blur', $event)
      // console.log(event);
      this.$emit('leave', event);
    },
    // onChange(event) {
    //   this.$emit('change', event)
    //   // console.log(event);
    //   // this.$emit('leave', event);
    // },
    onEnter(event) {
      this.$emit('enter', event);
    }
  }, 
  computed: {
    validation() {
      return this.require ? this.value != "" : null;
    },
    getValue() {
      return this.dateValue();
    },
    isDisable() {
      return ((this.value != '' && this.editable == false) || this.disabled);
    }
  },
  props: {
    type: {
      type: String,
      default: 'text',
    }, 
    id: {
      type: String,
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    first: {
      type: String,
      default: ''
    },
    last: {
      type: String,
      default: ''
    },
    value: null,
    require: {
      default: false
    },
    disabled: {
      default: false
    },
    editable: {
      default: true
    },
    mask: null,
    date: {
      default: true
    },
    max: {
      type: Number,
      default: -1
    }
  },
};
</script>
<template>
  <div class="form-group">
    <b-form-group
        class="mb-3"
        :label="$t(label)"
        :label-for="id"
    >
      <div class="input-group">
        <label v-show="first != ''" class="input-group-text" :for="id">{{first.includes('.') ?  $t(first) : first}}</label>
        <b-form-input
          :id="id"
          :type="type"
          :disabled="isDisable"
          :placeholder="placeholder == '' ? $t(label) : $t(placeholder)"
          :value="getValue" 
          v-on:input="$emit('input', $event)"
          v-on:blur="onBlur"
          @keyup.enter="onEnter"
          v-mask="mask"
          :state="validation"
          :maxlength="max"
        ></b-form-input>
        <label v-show="last != ''" class="input-group-text" :for="id">{{last.includes('.') ? $t(last) : last}}</label>
      </div>
      <b-form-invalid-feedback v-show="require" :state="validation">
        <span>{{`${$t('general.please-enter')} ${$t(label)}`}}</span>
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>